import React, { createContext, useContext } from "react";
import { useAuth } from "../hooks/useAuth";
import type { User, UserRole, LoginResult } from "../hooks/useAuth";

/** The console session (NU Core SSO, #590). See src/hooks/useAuth.ts. */
type AuthContextValue = ReturnType<typeof useAuth>;

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuthContext(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
}

export type { User, UserRole, LoginResult };
